import { DatePicker, type FormItemProps, type TimeRangePickerProps } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { CSSProperties, FC } from "react";

import { FormItem } from "./FormItem";

interface FormTimeRangerPickerProps
  extends Omit<FormItemProps, "name">,
    Pick<TimeRangePickerProps, "allowEmpty" | "placeholder" | "format" | "onChange" | "allowClear" | "presets"> {
  name: string | number | (string | number)[];
  formItemStyle?: CSSProperties;
}

export const DATE_RANGE_PICKER_PRESETS: TimeRangePickerProps["presets"] = [
  { label: "今日", value: [dayjs().startOf("day"), dayjs().endOf("day")] },
  { label: "昨日", value: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")] },
  { label: "最近7日間", value: [dayjs().subtract(6, "day").startOf("day"), dayjs().endOf("day")] },
  { label: "最近30日間", value: [dayjs().subtract(29, "day").startOf("day"), dayjs().endOf("day")] },
  { label: "今月", value: [dayjs().startOf("month"), dayjs().endOf("month")] },
];

export const FormDateRangePicker: FC<FormTimeRangerPickerProps> = ({
  name,
  getValueProps,
  normalize,
  allowEmpty,
  placeholder,
  format = "YYYY/MM/DD",
  onChange,
  allowClear,
  colon = true,
  ...props
}) => {
  const mergedGetValueProps =
    getValueProps ??
    ((value) => {
      if (!value) {
        return { value };
      } else if ("start_time" in value && "end_time" in value) {
        return { value: [dayjs(value.start_time), dayjs(value.end_time)] };
      }
      return { value };
    });
  const mergedNormalize =
    normalize ??
    ((values?: [Dayjs, Dayjs]) => {
      if (!values) return;
      const result = {
        start_time: values[0]?.format(),
        end_time: values[1]?.format(),
      };
      return result;
    });
  return (
    <FormItem colon={colon} getValueProps={mergedGetValueProps} name={name} normalize={mergedNormalize} {...props}>
      <DatePicker.RangePicker
        allowClear={allowClear}
        allowEmpty={allowEmpty}
        className="w-[280px]"
        format={format}
        onChange={onChange}
        placeholder={placeholder}
        placement="bottomRight"
        presets={DATE_RANGE_PICKER_PRESETS}
      />
    </FormItem>
  );
};
